import { makeAutoObservable, runInAction } from "mobx";
import { RootStore } from "./RootStore";
import { TariffGroupingDTO } from "../backend-types";
import { apiService } from "../ApiService";
import { API_CONFIG } from "../config/api.config";

export class TariffGroupingStore {
  tariffGroupings: TariffGroupingDTO[] = [];
  isLoading: boolean = false;
  error: string | null = null;

  constructor(private rootStore: RootStore) {
    makeAutoObservable(this);
  }

  async refreshTariffGroupings() {
    this.isLoading = true;
    try {
      const response = await apiService.get<TariffGroupingDTO[]>(API_CONFIG.ENDPOINTS.TARIFF_GROUPINGS_ALL);
      runInAction(() => {
        this.tariffGroupings = response;
        this.isLoading = false;
        this.error = null;
      });
    } catch (error) {
      runInAction(() => {
        this.error = "Fehler beim Laden der Tarif-Gruppierungen";
        this.isLoading = false;
      });
    }
  }

  async createTariffGrouping(tariffGrouping: Omit<TariffGroupingDTO, "id">) {
    try {
      const response = await apiService.post<TariffGroupingDTO>(API_CONFIG.ENDPOINTS.TARIFF_GROUPINGS_CREATE, tariffGrouping);

      runInAction(() => {
        this.tariffGroupings.push(response);
        this.error = null;
      });
      return response;
    } catch (error) {
      runInAction(() => {
        this.error = "Fehler beim Erstellen der Tarif-Gruppierung";
      });
      throw error;
    }
  }

  async deleteTariffGrouping(id: string) {
    try {
      await apiService.delete(`${API_CONFIG.ENDPOINTS.TARIFF_GROUPINGS_DELETE}/${id}`);

      runInAction(() => {
        this.tariffGroupings = this.tariffGroupings.filter((tg) => tg.id !== id);
        this.error = null;
      });
    } catch (error) {
      runInAction(() => {
        this.error = "Fehler beim Löschen der Tarif-Gruppierung";
      });
      throw error;
    }
  }

  async updateTariffGrouping(id: string, updates: Partial<TariffGroupingDTO>) {
    try {
      const response = await apiService.put<TariffGroupingDTO>(`${API_CONFIG.ENDPOINTS.TARIFF_GROUPINGS_UPDATE}/${id}`, updates);

      runInAction(() => {
        const index = this.tariffGroupings.findIndex((tg) => tg.id === id);
        if (index !== -1) {
          this.tariffGroupings[index] = response;
        }
        this.error = null;
      });
      return response;
    } catch (error) {
      runInAction(() => {
        this.error = "Fehler beim Aktualisieren der Tarif-Gruppierung";
      });
      throw error;
    }
  }
}
